/** Sem "Dom" de propósito: nenhuma unidade Kumon funciona aos domingos (`DiaSemana` ainda aceita `DOM`). */
export const DIAS_SEMANA = [
  { valor: 'SEG', label: 'Seg' },
  { valor: 'TER', label: 'Ter' },
  { valor: 'QUA', label: 'Qua' },
  { valor: 'QUI', label: 'Qui' },
  { valor: 'SEX', label: 'Sex' },
  { valor: 'SAB', label: 'Sáb' },
] as const;

/** Colunas das grades da Agenda, sem Sábado (raro): só afeta a grade; cadastros continuam oferecendo Sábado via `DIAS_SEMANA`. */
export const DIAS_SEMANA_GRADE = DIAS_SEMANA.filter((dia) => dia.valor !== 'SAB');

const ORDEM_DIA: Record<string, number> = {
  DOM: 0,
  SEG: 1,
  TER: 2,
  QUA: 3,
  QUI: 4,
  SEX: 5,
  SAB: 6,
};
const LABEL_DIA: Record<string, string> = Object.fromEntries(
  DIAS_SEMANA.map((dia) => [dia.valor, dia.label]),
);

export function horariosTexto(horarios: { diaSemana: string; horario: string }[]): string {
  return [...horarios]
    .sort(
      (a, b) =>
        (ORDEM_DIA[a.diaSemana] ?? 0) - (ORDEM_DIA[b.diaSemana] ?? 0) ||
        a.horario.localeCompare(b.horario),
    )
    .map((h) => `${LABEL_DIA[h.diaSemana] ?? h.diaSemana} ${h.horario}`)
    .join('  ·  ');
}
